import React, { useContext, useState, useEffect } from "react";
import { connect } from "react-redux";
import { TableContext } from "../../index";
import { Checkbox } from "../../view/Checkbox";
import { deepCopy } from "../../utils";
import { useHistory } from "react-router-dom";
import { PopupContext } from "../../index";
import { showSuccessToast } from "../../validation/ToastContainer";
import { POPUP_TYPES } from "../../view/popup/PopupContainer";
import { changeParameter } from "../ruleService";
import { MoreHorizontal } from "lucide-react";


function ParametersTableRow({ data, index, totalRows, userCapability }) {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);
    const { setPopup } = useContext(PopupContext);

    //#region Set User Capabilities
    const [manageParameterCapability, setManageParameterCapability] = useState(-1);
    useEffect(() => {
        if (userCapability) {
            const manageParameterPermission = userCapability.find(item =>
                item.component === "manageparameter" && item.type === "page")?.permission;
            setManageParameterCapability(manageParameterPermission);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }

        setConfig({
            ...config,
            selected: selectedRows,
            selectAll: selectedRows.length === totalRows
        })
    }

    const onButtonClick = () => data && setPopup(
        {
            type: POPUP_TYPES.EDIT_PARAMETER,
            selectedParameter: deepCopy(data),
            confirm: confirmParameterEditing
        }
    )

    const confirmParameterEditing = async (parameter) => {
        await changeParameter(parameter)
            .then(success => success && showSuccessToast('Parameter Edited Successfully', 'Edit Parameter'));
        history.go(0);
    }

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
            </td>
            <td><span className="font-weight-bold">{data.name}</span></td>
            <td>{data.value}</td>
            <td>
                <button
                    type="button"
                    className={`parameters-row-action-v2 ${manageParameterCapability === 0 ? 'disabled' : ''}`}
                    onClick={manageParameterCapability === 0 ? null : () => onButtonClick()}
                    disabled={manageParameterCapability === 0}
                    aria-label={`Edit parameter ${data.name}`}
                >
                    <MoreHorizontal />
                </button>
            </td>
        </tr>
    )

}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}
export default connect(mapStateToProps)(ParametersTableRow);
